import { createPulse, type GetTenantEventsFullParams, type PulseClient, type TrackBatchItem } from "./client";
import type { PulseClientConfig } from "./config";
import { PulseError } from "./errors";
import type { PulseEventName, TrackOptions } from "./events";

type PulseGlobal = {
  init: (config: PulseClientConfig) => void;
  track: (eventName: PulseEventName, options?: TrackOptions) => Promise<unknown>;
  trackBatch: (items: TrackBatchItem[]) => Promise<unknown>;
  flush: () => Promise<unknown>;
  getTenantEventsFull: (params?: GetTenantEventsFullParams) => Promise<unknown>;
};

function notInitializedError(methodName: string): PulseError {
  return new PulseError(
    0,
    "not_initialized",
    `window.Pulse.${methodName} was called before window.Pulse.init(config)`,
  );
}

export function installPulseGlobal(target: typeof globalThis): void {
  let client: PulseClient | undefined;

  const pulse: PulseGlobal = {
    init(config) {
      client = createPulse(config);
    },
    track(eventName, options) {
      if (!client) return Promise.reject(notInitializedError("track"));
      return client.track(eventName, options);
    },
    trackBatch(items) {
      if (!client) return Promise.reject(notInitializedError("trackBatch"));
      return client.trackBatch(items);
    },
    flush() {
      if (!client) return Promise.reject(notInitializedError("flush"));
      return client.flush();
    },
    getTenantEventsFull(params) {
      if (!client) return Promise.reject(notInitializedError("getTenantEventsFull"));
      return client.getTenantEventsFull(params);
    },
  };

  (target as typeof globalThis & { Pulse: PulseGlobal }).Pulse = pulse;
}
